import * as Sentry from '@sentry/react';
import { Crisp } from 'crisp-sdk-web';
import { UserProfile } from '@teetsh/app/src/types/user';
import Cookies from 'js-cookie';
import { PostHog } from 'posthog-js';

function identifyCrispUser(user: UserProfile) {
  window.CRISP_TOKEN_ID = user.crispTokenId;
  setTimeout(() => {
    if (!!window?.$crisp?.do) {
      Crisp.session.reset();
      if (Crisp.isCrispInjected() && !!window?.$crisp?.do) {
        Crisp.setHideOnMobile(true);

        Crisp.user.setEmail(user.email);
        Crisp.user.setNickname(`${user.givenName} ${user.familyName}`);

        Crisp.session.setData({
          user_id: user.id,
          plan: user.currentPlan,
          optin: user.optin,
        });
      }
      if (user.disableChat) {
        Crisp.chat.hide();
      }
    }
  }, 1000);
  if (Crisp.isCrispInjected() && !!window?.$crisp?.do) {
    Crisp.setHideOnMobile(true);

    Crisp.user.setEmail(user.email);
    Crisp.user.setNickname(`${user.givenName} ${user.familyName}`);

    Crisp.session.setData({
      user_id: user.id,
      plan: user.currentPlan,
      optin: user.optin,
    });
    Crisp.setTokenId(user.crispTokenId);
    if (user.disableChat) {
      Crisp.chat.hide();
    }
  }
}

export default function identifyUserToExternalServices(
  user?: UserProfile,
  posthog?: PostHog,
) {
  if (import.meta.env.VITE_IS_DEV === 'true' || !user) {
    return;
  }
  const username = `${user.givenName} ${user.familyName}`;

  try {
    if (Cookies.get('teetshadmin')) {
      posthog?.opt_out_capturing();
    }
    if (!Cookies.get('teetshadmin')) {
      identifyCrispUser(user);
      if (posthog) {
        posthog?.identify(user?.id, {
          email: user.email,
          first_name: user.givenName,
          last_name: user.familyName,
        });
      }
      if (user.disableChat) {
        setTimeout(() => {
          Crisp.chat.hide();
        }, 1000);
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('Crisp session not set');
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  if (
    import.meta.env.VITE_ENVIRONMENT === 'production' ||
    import.meta.env.VITE_ENVIRONMENT === 'recette'
  ) {
    Sentry.configureScope(scope => {
      scope.setUser({ email: user.email, username });
    });
  }
}
